import { render, staticRenderFns } from "./delivery-order-product.vue?vue&type=template&id=04de796c&scoped=true&"
import script from "./delivery-order-product.vue?vue&type=script&lang=js&"
export * from "./delivery-order-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04de796c",
  null
  
)

export default component.exports